<script setup lang="ts">
/*
  Root-Komponente des Widgets.
  Keine Logik hier – alles läuft über Router + Stores.
*/
</script>

<template>
  <router-view />
</template>
